export default __webpack_public_path__ + "static/media/H1015.5.a5427c20.mp3";